import axios from 'axios'
import config from '@/config'

const adminService = {
  getCompanyInfo(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/company/info`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getCICompanyInfo(context, companyName) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/company/info/ci?companyName=${companyName}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getCompanyInfoByCompanyId(context, companyId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/admin/companyinfo?companyId=${companyId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  // getCompanyList(context) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       method: 'GET',
  //       url: '/admin/booking/listcompany'
  //     })
  //       .then(response => {
  //         resolve(response.data)
  //       }).catch(e => {
  //         reject(e.response)
  //       })
  //   })
  // },
  getCompaniesList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/admin/companylist',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getCandidatesList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/admin/candidatelist',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getRecruitersList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/admin/recruiterlist',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },

  getCloseupCandidatesList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/admin/candidatelist?closeup=true',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  upgradeCloseup(context, data) {
    console.log('here')
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/closeup/admin/upload',
        data: data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getRecruitersByCompany(context, compId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/admin/recruiterbycompany?compId=${compId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getProductsByCompany(context, compId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/admin/listallproduct?compId=${compId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getProducts(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/admin/listallproduct`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getVouchers(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + `/closeup/admin/list/voucher`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  activateUserAccount(context, activateUserModel) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/activateaccount',
        data: activateUserModel,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  activateCompany(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/activatecompany',
        data: payload,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  activateCIFeatures(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/company/misc/update',
        data: payload,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteUserAccount(context, deleteUserModel) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/deleteaccount',
        data: deleteUserModel,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteApplicant(context, deleteApplicantModel) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/jobcode/admin/delete/applicant',
        data: deleteApplicantModel,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteCompany(context, deleteCompanyModel) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/deletecompany',
        data: deleteCompanyModel,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateTranscribeText(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/music/insert/transcribetext',
        data: payload,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getBookingList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/admin/booking/list',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getAppliedListByProduct(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/admin/bybookingid/appliedlist?bookingId=${data.bookingId}&compId=${data.companyId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getCandidateUploadedVideos(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL_V2 +
          `/admin/bybookingid/candidatevideos?bookingId=${data.bookingId}&candidateEmail=${data.candidateEmail}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  uploadInterview(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data.formData,
        url: config.BASE_API_URL_V2 + `/jobcode/admin/upload/interview?id=${data.companyId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createProduct(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/admin/booking/create/product',
        data: data,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  bookCandidateDossier(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/dossier/update',
        data: data,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createVoucher(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/closeup/admin/create/voucher',
        data: data,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteVoucher(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/closeup/admin/delete/voucher',
        data: data,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  fetchEmailAlerts(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL_V2 + '/admin/settings',
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  saveEmailAlerts(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + '/admin/insert/settings',
        data: payload,
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(response.statusText ? response.statusText : 'Error')
          }
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  uploadCompanyGalleryImage(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/company/upload/image`,
        data: payload.data,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  removeCompanyGalleryImage(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/company/delete/image?companyImageGallery=${payload.data}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  connectWebEx(id) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/company/integration/webex`,
        data: { companyId: id },
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  checkWebExCode(code, compId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/company/integration/webex/accepted`,
        data: { webexAuthCode: code, companyId: compId },
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  disconnectWebEx(compId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL_V2 + `/company/integration/webex/disconnect`,
        data: { companyId: compId },
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
}
export default adminService
